import { render, staticRenderFns } from "./AptReminderSettings.vue?vue&type=template&id=d9a54e26&scoped=true"
import script from "./AptReminderSettings.vue?vue&type=script&lang=js"
export * from "./AptReminderSettings.vue?vue&type=script&lang=js"
import style0 from "./AptReminderSettings.vue?vue&type=style&index=0&id=d9a54e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a54e26",
  null
  
)

export default component.exports